export default __webpack_public_path__ + "static/media/ic-portal.a321b9fc.svg";